export const template = 1;
export const banner = 2;
//export const IPADWIDTH = 1030; //Magic Number as per Ipad width
